import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { SitesDropdownRespSuccess } from './types';
import { useAppContext } from '@contexts/app';

export const useSitesDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { data, error, isPending } = useQuery<SitesDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.sites,
    queryFn: () => queryFetch({ url: `dropdowns/concrete_direct_sites` }),
    placeholderData: (previousData) => previousData as SitesDropdownRespSuccess,
    enabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
